export default __webpack_public_path__ + "static/media/logo.902c9ea3.svg";